export default __webpack_public_path__ + "static/media/bannerServices.cf0ea532.png";